import {
  Array as RTArray,
  Null,
  Union,
  Literal,
  Number as RTNumber,
  Partial,
  Record,
  Static,
  String as RTString,
  Undefined
} from 'runtypes';
import { fundingTypes } from '../../flows/shared/utils';

export const ExternalBankAccount = Partial({
  accountNumber: RTString,
  accountName: RTString,
  liquidationOption: RTString,
  estimatedTransferAmount: RTNumber,
  accountType: RTString,
  cusip: RTString
});

export type StaticExternalBankAccount = Static<typeof ExternalBankAccount>;

const BankChoiceMethod = Union(
  Literal(fundingTypes.MANUAL),
  Literal(fundingTypes.EXTERNAL),
  Literal(fundingTypes.EXISTING_BANK)
);

export type StaticBankChoiceMethod = Static<typeof BankChoiceMethod>;

export const BankAccountReference = Record({
  bankAccountType: RTString,
  bankChoiceMethod: BankChoiceMethod,
  existingBankToken: RTString.Or(Undefined).Or(Null),
  manualEntryToken: RTString.Or(Undefined).Or(Null),
  externalProviderToken: RTString.Or(Undefined).Or(Null),
  externalProviderAuthenticationToken: RTString.Or(Undefined).Or(Null),
  bankAccountOwners: RTArray(RTString)
    .Or(Undefined)
    .Or(Null),
  bankAccountNumber: RTString.Or(Undefined).Or(Null),
  bankRoutingNumber: RTString.Or(Undefined).Or(Null)
});

export type StaticBankAccountReference = Static<typeof BankAccountReference>;

export const BankFailure = Record({
  bankChoiceMethod: RTString,
  bankName: RTString,
  bankFailureReason: RTString
});

export type StaticBankFailure = Static<typeof BankFailure>;

export const AccountTransferDetails = Record({
  agreementId: RTString,
  redemptionAmount: RTNumber
});

export type StaticAccountTransferDetails = Static<
  typeof AccountTransferDetails
>;
